import { CreateStepArgs } from '@/lib/Steppers/CreateStepper/types';
import { CampaignIcon, DataSourcesIcon } from '@/lib';
import { SmsCampaignStep } from './SmsCampaignValidation';

export type SmsCampaignMode = 'create' | 'edit';

export const SMS_CAMPAIGN_STEPS = [
  {
    id: 'TitleDescription',
    title: 'campaign:smsWorkspace.steps.title',
    icon: CampaignIcon,
    isCompleted: false,
  },
  {
    id: 'AudienceSelection',
    title: 'campaign:smsWorkspace.steps.audienceSelection',
    icon: DataSourcesIcon,
    isCompleted: false,
  },
  {
    id: 'SenderSelection',
    title: 'campaign:smsWorkspace.steps.senderSelection',
    icon: DataSourcesIcon,
    isCompleted: false,
  },
  {
    id: 'PreviewSchedule',
    title: 'campaign:smsWorkspace.steps.previewAndSend',
    icon: CampaignIcon,
    isCompleted: false,
  },
] as unknown as ReadonlyArray<CreateStepArgs<SmsCampaignStep> & { icon: typeof CampaignIcon; isCompleted: boolean }>;

export const SMS_CAMPAIGN_EDIT_STEPS = SMS_CAMPAIGN_STEPS.filter((step) => step.id !== 'SenderSelection') as ReadonlyArray<
  CreateStepArgs<SmsCampaignStep> & { icon: typeof CampaignIcon; isCompleted: boolean }
>;

export const getSmsCampaignSteps = (mode: SmsCampaignMode) => (mode === 'edit' ? SMS_CAMPAIGN_EDIT_STEPS : SMS_CAMPAIGN_STEPS);
